import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

import { useStyles } from './styles';

interface IKeyCap {
  label: string;
  accent?: boolean;
}

export const KeyCap = ({ label, accent = false }: IKeyCap) => {
  const classes = useStyles();

  return (
    <Box sx={{ ...classes.keyCap, ...(accent ? classes.keyCapAccent : {}) }}>
      {label}
    </Box>
  );
};

export const WasdCluster = () => {
  const classes = useStyles();

  return (
    <Box sx={classes.keyCluster}>
      <KeyCap label="W" />
      <KeyCap label="A" />
      <KeyCap label="S" />
      <KeyCap label="D" />
    </Box>
  );
};

export const ArrowCluster = () => {
  const classes = useStyles();

  return (
    <Box sx={classes.keyCluster}>
      <KeyCap label="↑" />
      <KeyCap label="←" />
      <KeyCap label="↓" />
      <KeyCap label="→" />
    </Box>
  );
};

export const MouseShape = () => {
  const classes = useStyles();

  return <Box sx={classes.mouse} />;
};

export const IconRing = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();

  return <Box sx={classes.iconRing}>{children}</Box>;
};
